import { request } from "../../api/api";

export const getAdminSettings = () => {
    return request.get("/admin-settings/")
};

export const adminSettingsUpdate = (data) => {
    return request.post("/admin-settings-update/",data)
};

export const timeZoneList = () => {
    return request.get("/timezone-list/")
};